
define('text!templates/pages/dashboard/panel.ejs',[],function () { return '<div class="panel-header">\n    <%= caption %>\n</div>\n\n<div class="panel-content">\n</div>\n';});

